/**
 * Enum for store branch type
 * @readonly
 * @enum {String}
 */
export default Object.freeze({
  AI: 'BETA (V.2)',
})
